import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import type { IOption } from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { useMemo, useRef } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { generateDurationOptions } from '../../../../../utils/generateOptions';
import { MAX_LOAN_DURATION } from '../../config/globals';
import { Step1Data } from '../../FormData.no.types';

export const LoanDurationField = () => {
  const { t } = useTranslation();

  const isDurationSet = useRef(false);

  const loanDurationOptions: RegisterOptions & { options: IOption[] } = useMemo(
    () => ({
      options: generateDurationOptions({
        lowerLimit: 1,
        upperLimit: MAX_LOAN_DURATION,
        step: 1,
        suffix: t('suffix.year'),
      }),
      registerOptions: {
        valueAsNumber: true,
        required: 'error.required',
      },
      onChange: () => {
        if (isDurationSet.current) return;
        isDurationSet.current = true;
      },
    }),
    [t]
  );

  return (
    <DropdownFieldUI<Step1Data>
      name="LoanApplication/LoanDuration"
      label={t('LoanDuration.label')}
      data-testid="loan-duration-dropdown"
      {...loanDurationOptions}
    />
  );
};
